import { Link, useRouter } from "@tanstack/react-router";
import { Loader2, AlertTriangle, RefreshCw, Home } from "lucide-react";
import { useEffect } from "react";

export function AdminPendingScreen() {
  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-4 text-center px-6">
        <div className="relative">
          <div className="absolute inset-0 rounded-full bg-primary/20 blur-xl animate-pulse" />
          <Loader2 className="relative h-10 w-10 text-primary animate-spin" />
        </div>
        <div>
          <p className="text-base font-medium text-foreground">Loading admin console</p>
          <p className="text-sm text-muted-foreground mt-1">Preparing your workspace…</p>
        </div>
      </div>
    </div>
  );
}

export function AdminErrorScreen({ error, reset }: { error: any; reset: () => void }) {
  const router = useRouter();

  useEffect(() => {
    // Log for debugging
    console.error("[admin route] load error:", error);
  }, [error]);

  const isChunkError =
    /Loading chunk|Failed to fetch dynamically imported module|ChunkLoadError|Importing a module script failed/i.test(
      error?.message ?? "",
    );

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-background px-6">
      <div className="max-w-md w-full rounded-2xl border border-border bg-card shadow-lg p-6 text-center">
        <div className="mx-auto h-12 w-12 rounded-full bg-destructive/10 flex items-center justify-center mb-4">
          <AlertTriangle className="h-6 w-6 text-destructive" />
        </div>
        <h1 className="text-lg font-semibold text-foreground">
          {isChunkError ? "New version available" : "Something went wrong"}
        </h1>
        <p className="text-sm text-muted-foreground mt-2">
          {isChunkError
            ? "The admin console was updated. Reload to get the latest version."
            : error?.message || "The admin console failed to load."}
        </p>
        <div className="flex flex-col sm:flex-row gap-2 mt-6 justify-center">
          <button
            type="button"
            onClick={() => {
              if (isChunkError) {
                window.location.reload();
                return;
              }
              router.invalidate();
              reset();
            }}
            className="inline-flex items-center justify-center gap-2 rounded-lg bg-primary text-primary-foreground px-4 py-2 text-sm font-medium hover:opacity-90 transition"
          >
            <RefreshCw className="h-4 w-4" />
            {isChunkError ? "Reload" : "Try again"}
          </button>
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 rounded-lg border border-border bg-background px-4 py-2 text-sm font-medium hover:bg-muted transition"
          >
            <Home className="h-4 w-4" />
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}
